<!DOCTYPE html>
<html lang="en">

<head>
    <!-- Google Tag Manager -->
    <script>(function (w, d, s, l, i) {
            w[l] = w[l] || []; w[l].push({
                'gtm.start':
                    new Date().getTime(), event: 'gtm.js'
            }); var f = d.getElementsByTagName(s)[0],
                j = d.createElement(s), dl = l != 'dataLayer' ? '&l=' + l : ''; j.async = true; j.src =
                    'https://www.googletagmanager.com/gtm.js?id=' + i + dl; f.parentNode.insertBefore(j, f);
        })(window, document, 'script', 'dataLayer', 'GTM-K2ZBWQ6');</script>
    <!-- End Google Tag Manager -->

    <meta charset="utf-8" />
    <title>Backseat Trader | Algorithmic Development & Trading </title>
    <meta name="viewport" content="width=device-width, initial-scale=1.0">
    <meta name="description"
        content="Backseat Trader - Trade and invest in cryptocurrencies, stocks, ETFs, currencies, indices and commodities or copy leading investors on eToro's disruptive trading platform." />
    <meta name="keywords" content="Backseat Trader" />
    <meta name="document-type" content="Public" />
    <meta name="document-rating" content="Safe for Kids" />
    <meta name="Expires" content="never" />
    <meta name="HandheldFriendly" content="True" />
    <meta name="YahooSeeker" content="Index,Follow" />
    <meta name="googlebot" content="Index, Follow ">
    <meta name="bingbot" content=" Index, Follow ">
    <meta name="distribution" content="global" />
    <meta name="language" content="english" />
    <meta name="rating" content="general" />
    <meta name="subject" content="according to Page " />
    <meta name="robots" content="ALL" />
    <meta name="revisit-after" content="1 days" />
    <meta name="generator" content="https://backseat-trader.com/" />

    <script type="text/javascript">
        if (screen.width <= 739) { window.location = "http://www.backseat-trader.com/m-index.html"; }
    </script>

    <!-- favicon -->
    <link rel="shortcut icon" href="images/favicon.ico">

    
 
    <style>
        body {
            font-size: 20px;
        }
    </style>
    <!-- Global site tag (gtag.js) - Google Analytics -->
    <script async src="https://www.googletagmanager.com/gtag/js?id=G-3LHC3Q4DKK"></script>
    <script>
        window.dataLayer = window.dataLayer || [];
        function gtag() { dataLayer.push(arguments); }
        gtag('js', new Date());

        gtag('config', 'G-3LHC3Q4DKK');
    </script>
</head>

<body>
    <!-- Google Tag Manager (noscript) -->
    <noscript><iframe src="https://www.googletagmanager.com/ns.html?id=GTM-K2ZBWQ6" height="0" width="0"
            style="display:none;visibility:hidden"></iframe></noscript>
    <!-- End Google Tag Manager (noscript) -->
    <header class="main_header">
        <div class="container">
            <nav class="navbar navbar-expand-lg">
                <a class="navbar-brand" href="#">
                    <span class="logoText">Backseat-Trader</span>
                </a>
                <button class="navbar-toggler" type="button" data-toggle="collapse"
                    data-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false"
                    aria-label="Toggle navigation">
                    <span class="navbar-toggler-icon"></span>
                </button>

                <div class="collapse navbar-collapse" id="navbarSupportedContent">
                    <ul id="myMenu" class="navbar-nav ml-auto">
                        <li class="nav-item menu-item"><a class="nav-link cool-link" href="#home">Home</a></li>
                        <li class="nav-item menu-item"><a class="nav-link cool-link" href="#about-us">About Us</a></li>
                        <li class="nav-item menu-item"><a class="nav-link cool-link" href="#eToro">eToro</a></li>
                        <li class="nav-item menu-item"><a class="nav-link cool-link" href="#backtesting">Backtesting</a>
                        </li>
                        <li class="nav-item menu-item"><a class="nav-link cool-link" href="#brochure">Brochure</a></li>
                        <li class="nav-item menu-item"><a class="nav-link cool-link" data-toggle="modal"
                                data-target="#exampleModal" data-whatever="@mdo">Contact</a></li>
                        <li class="nav-item menu-item"><a
                                class="nav-link btn theme-btn animate hoverclr JoinusoneToro_0"
                                href="https://www.etoro.com/?ref=18514998&compEligible=0&BannerID=4026&utm_medium=Direct&utm_source=11&utm_content=0&utm_serial=ShortURL_WS_CP&utm_campaign=ShortURL_WS_CP&utm_term="
                                target="_blank" data-toggle="tooltip" data-placement="bottom"
                                title="Get started with US$500">Join us on eToro</a></li>
                    </ul>
                </div>
            </nav>
        </div>
    </header>


    <div id="one_page" class="allsection">
        <section id="home" class="section home_hero mainHero">
            <div class="container">
                <div class="row align-items-center">
                    <div class="col-lg-6">
                        <div class="textBox">
                            <h1 class="wow fadeInUp" data-wow-delay=".2s">Simplified Online Trading</h1>
                            <div class="mt-2">
                                <p class="wow fadeInUp" data-wow-delay="1s"><i class="fa fa-hand-o-right"
                                        aria-hidden="true"></i> No trading experience required</p>
                                <p class="wow fadeInUp" data-wow-delay="3s"><i class="fa fa-hand-o-right"
                                        aria-hidden="true"></i> Backseat-trader trades for you</p>
                                <p class="wow fadeInUp" data-wow-delay="5s"><i class="fa fa-hand-o-right"
                                        aria-hidden="true"></i> Join Backseat-trader with just US$500</p>
                            </div>
                        </div>
                    </div>
                    <div class="col-lg-6">
                        <div class="imgBox wow fadeInRight" data-wow-delay=".2s">
                            <!-- <img class="img-fluid" src="images/hero-img.png" alt=""> --><img class="img-fluid"
                                src="assets/img/banner-top01.jpg" alt="Online Trading">
                        </div>
                    </div>
                </div>
            </div>
        </section>
        <!-- 
            HOME COMPONENT ^
        -->
        <section id="square-grph" class="section section-padding">
            <div class="container">
                <div class="section-title text-center">
                    <h2 class="wow fadeInUp" data-wow-delay=".2s">Month-end Report</h2>
                </div>
                <div class="row">
                    <div class="col-md-12">
                        <div class="graph_wrapper">
                            <img src="assets/img/eToro-Plot-Cliqued-Media.jpg" alt="Month-end Report" class="img-fluid">
                            <div class="btnBox mt-5 wow fadeInUp" data-wow-delay=".6s"
                                style="visibility: visible; animation-delay: 0.6s; animation-name: fadeInUp;">
                                <a href="https://www.etoro.com/?ref=18514998&compEligible=0&BannerID=4026&utm_medium=Direct&utm_source=11&utm_content=0&utm_serial=ShortURL_WS_CP&utm_campaign=ShortURL_WS_CP&utm_term="
                                    target="_blank" class="btn theme-btn hoverclr animate JoinusoneToro1">Join us on
                                    eToro</a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
        <!-- 
            MONTH END REPORT GRAPH ^
        -->
        <app-about-us></app-about-us>
        <!--
            ABOUT US COMPONENT ^
        -->
        <app-etoro></app-etoro>
        <!-- 
            ETORO COMPONENT ^
        -->
        <app-backtesting></app-backtesting>
        <!--
            BACKTESTING COMPONENT ^
        -->
        <app-brochure></app-brochure>
        <!--
            BROCHURE COMPONENT ^
        -->
    </div>
    <!--Popup for iframe view-->

    <div class="modal fade bd-example-modal-lg model__view" tabindex="-1" role="dialog"
        aria-labelledby="myLargeModalLabel" aria-hidden="true">
        <div class="modal-dialog modal-lg">
            <div class="modal-content">
                <iframe width="100%" src="https://www.etoro.com/people/cosmicetoro/portfolio"></iframe>
            </div>
        </div>
    </div>
    <!-- Modal https://www.etoro.com/people/cosmicetoro/portfolio-->
    <script>
        $(document).ready(function () {
            $('#signup').submit(function () {
                $("#message").html("Adding your email address...");
                $.ajax({
                    url: 'mailchimp/store-address.php', // proper url to your "store-address.php" file
                    type: 'POST', // <- IMPORTANT
                    data: $('#signup').serialize() + '&ajax=true',
                    success: function (msg) {
                        var message = $.parseJSON(msg);
                        console.log(message);
                        var result = '';

                        if (message.status === 'subscribed') { // success
                            result = 'Subscribed Succesfully';
                        } else { // error
                            result2 = 'Error: ' + message.detail;
                            result = result2.replace('Use PUT to insert or update list members.', '');
                        }
                        $('#message').html(result); // display the message
                    }
                });
                return false;
            });
        });
    </script>
</body>

</html>